import { postJson, uploadForm } from './client'
import type { UploadAccepted } from '../types/onboarding'

export interface ImportResult { rows: number; people: number; companies: number; skipped: number }

// The LinkedIn and CRM connectors. The upload is STAGED: an Excel workbook or a CSV export becomes a
// batch of proposals on Onboard Contacts, and nothing reaches the contacts until a person commits it
// (DEC-2026-09-10-06). The two direct-merge calls below are the older path, kept for anything that
// still posts a CSV body; no screen sends a person down them.
const base = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/connectors`

export const connectorsApi = {
  /** A contact list from the Import Data screen: staged as a batch, reviewed at /onboarding/{batchId}. */
  upload: (spoke: string, file: File, onProgress?: (fraction: number) => void) => {
    const form = new FormData()
    form.append('file', file, file.name)
    return uploadForm<UploadAccepted>(`${base(spoke)}/upload`, form, onProgress)
  },

  linkedin: (spoke: string, csv: string) => postJson<ImportResult>(`${base(spoke)}/linkedin/import`, { csv }),
  crm: (spoke: string, csv: string) => postJson<ImportResult>(`${base(spoke)}/crm/import`, { csv }),
}
